module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SpReschedulingList"
    }
  }, [_c('h1', [_vm._v("あなたに届いている依頼")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(content, index) {
    return _c('tr', {
      key: content.data
    }, [_c('td', [_vm._v(_vm._s(_vm.getUsername(content.sender)) + " 様")]), (content.reason) ? _c('td', [_vm._v(_vm._s(content.reason))]) : _vm._e(), (content.rescheduling_hash) ? _c('td', [_c('a', {
      attrs: {
        "href": 'SpRescheduling/' + content.rescheduling_hash
      }
    }, [_vm._v("処理ページへ")])]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("依頼主")]), _c('th', [_vm._v("理由")]), _c('th', [_vm._v("処理ページ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a9171d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a9171d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/ReschedulingPage/SpreschedulingList.vue
// module id = 733
// module chunks = 0